const getters = {
  selectedPerson: state => {
    return state.person ? state.person : null
  },
}

export default getters
